<template>
  <v-app>

    <div
      v-if="scrollVisible && baseStore.isDesktop"
      class="top-strip pa-2"
    >
      <!-- Left-aligned content -->
  
      <span class="top-strip-text mt-0 px-0 pt-1">
        &nbsp;&nbsp; Unterstützt durch die <b>WaizmannTabelle</b> | das Original seit 1995
    
      </span>

      <!-- Right-aligned content -->
      <span
        v-if="baseStore.isDesktop"
        class="top-strip-copy mt-0 py-0 pt-1"
      >
        &copy; PickPoint.live
      </span>
    </div>

    <v-app-bar
      v-scroll="makeSmall"
      :style="styleSwitch"
      app
      elevation="1"
      clipped-left
      :extended="showExtension"
      :extension-height="showExtensionHeight"
      ref="appBarRef"
    >


      <router-link to="/" style="text-decoration: none" class="text-black">
        <span v-if="baseStore.isDesktop" class="brand-row">
         
          <img
                  :src="require('@/assets/pickpoint.png')"
           
                  width="160"
                  class="ml-4"
       
                />
         <span class="brand-claim ml-12" > 
           "handverlesene" online <b class="brand-claim-strong">Experten-Webinare</b> 
           <span> für Ihr Praxismanagement</span>
         </span>
        </span>
        <span v-if="!baseStore.isDesktop" style="font-size: 18px; font-weight: bold; cursor: pointer"><span class="text-muted-brand">PickPoint</span></span>
      </router-link>
      <v-spacer />
      <div v-if="showLoginButtons" class="header-auth-actions">
        <v-btn
          v-if="!isLoggedIn"
          class="auth-btn"
          variant="outlined"
          size="small"
          @click="openLoginDialog"
        >
          Login
        </v-btn>
        <template v-else>
          <v-btn
            v-if="Number(userStore?.userData?.user_is_admin || userStore?.userData?.user?.user_is_admin) === 1"
            class="auth-btn auth-btn-secondary mr-2"
            variant="tonal"
            size="small"
            @click="openAdminTools"
          >
            Adminbereich
          </v-btn>
          <v-btn
            class="auth-btn auth-btn-secondary mr-2"
            variant="tonal"
            size="small"
            @click="openMeineWebinare"
          >
            Meine Webinare
          </v-btn>
          <v-btn
            class="auth-btn"
            variant="tonal"
            size="small"
            @click="startLogout"
          >
            Logout
          </v-btn>
        </template>
      </div>

    
    </v-app-bar>

    <!-- <v-navigation-drawer  @click="showExtension = false"   v-model="showMenue" style="margin-top: 50px;max-width: 240px;" app clipped>
              <MenueDefault v-if="showMenue" />
    </v-navigation-drawer> -->
    <div id="content" :style="baseStore.isDesktop ? 'margin-top: 90px;' : 'margin-top: 50px;'">
      <LoaderOverlay />
      <ErrorOverlay />
      <SuccessOverlay />
      <div ref="routerContainer" class="router-container mt-4" style="background-color: #f8f9fb;min-height: 1400px;">
        <!-- Startseite ohne erzwungene Desktop-Breite, damit sie mobil responsive ist -->
        <router-view :style="route.name === 'home' ? null : 'min-width: 1400px;'"></router-view>
      </div>
    </div>
    <v-footer app>
      <v-col class="text-center">
        <span>&copy; 2023 PickPoint  Alle Rechte vorbehalten.</span>
      </v-col>
    </v-footer>
    <v-dialog v-model="userStore.showLogin" width="666">
      <v-card>
        <v-card-text>
          <LoginView :newRoute="newRoute" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script setup>
import { inject, ref, onMounted, watch, computed } from 'vue'

import { useRoute, useRouter } from 'vue-router'

//import MenueDefault from '@/components/sites/modules/MenueDefault.vue';

import  LoginView from '@/components/objects/user/LoginView.vue'



// Stores und Services injizieren

const userStore = inject('userStore')
const baseStore = inject('baseStore')
const baseCalls = inject('baseCalls')
const successStore = inject('successStore')
const router = useRouter()


const route = useRoute()
// Reaktive Variablen
const showExtension = ref(false)
const showExtensionHeight = ref(140)


const newRoute = ref('')
const styleSwitch = ref('margin-top:40px;')
const scrollVisible = ref(true)
const showLoginButtons = ref(true)
const isLoggedIn = computed(() => !!userStore?.userData)

const PICK_USER_KEY = 'pick_user'
const PICK_USER_SESSION_KEY = 'pick_user_session'

function openLoginDialog() {
  newRoute.value = '/webinare'
  userStore.setLoginView(true)
}

function writeUserSession(user) {
  try {
    localStorage.setItem(PICK_USER_KEY, JSON.stringify(user || null))
    sessionStorage.setItem(PICK_USER_SESSION_KEY, '1')
  } catch (e) {
    console.warn('Session speichern fehlgeschlagen:', e)
  }
}

function clearUserSession() {
  try {
    localStorage.removeItem(PICK_USER_KEY)
    sessionStorage.removeItem(PICK_USER_SESSION_KEY)
  } catch (e) {
    console.warn('Session löschen fehlgeschlagen:', e)
  }
}

function restoreUserSession() {
  try {
    const hasSession = sessionStorage.getItem(PICK_USER_SESSION_KEY)
    const rawUser = localStorage.getItem(PICK_USER_KEY)
    if (!hasSession || !rawUser) return
    const parsed = JSON.parse(rawUser)
    if (parsed) {
      userStore.setUser(parsed)
    }
  } catch (e) {
    console.warn('Session wiederherstellen fehlgeschlagen:', e)
  }
}

async function getLoggedUser() {
  if (!showLoginButtons.value) return
  const data = { action: 'loggeduser', id: 0 }
  try {
    const response = await baseCalls.userGet(data)
    if (response?.data?.user) {
      userStore.setUser(response.data.user)
      writeUserSession(response.data.user)
    } else {
      userStore.setUser(null)
      clearUserSession()
    }
  } catch (err) {
    console.log(err)
  }
}

async function startLogout() {
  const data = { action: 'logout', id: 0 }
  try {
    const response = await baseCalls.userGet(data)
    if (response?.data?.success) {
      userStore.setUser(null)
      userStore.setLoginView(false)
      clearUserSession()
      successStore?.setSuccess?.(true, 'Logout erfolgreich', 'Sie wurden erfolgreich ausgeloggt.')
      router.push('/')
    }
  } catch (err) {
    console.log(err)
  }
}

function openMeineWebinare() {
  router.push('/webinare')
}

function openAdminTools() {
  router.push('/admin-tools')
}




// Aktuelle Route initial setzen
//const route = useRoute()
//newRoute.value = route.fullPath

// Bei jeder Routenänderung aktualisieren
// watch(
//   () => route.fullPath,
//   (newVal) => {
//     newRoute.value = newVal
//   }
// )

// Extension-Logik


// function goToLink(id){
//     if (id == 1){
//       router.push({
//         name: "find",
//       });
//     }
//     if (id == 2){
//       router.push({
//         name: "webinareindex",
//       });
//     }
//   }



// AppBar-Scroll-Logik
function makeSmall() {
  const currentScrollPosition =
    window.pageYOffset || document.documentElement.scrollTop
  if (currentScrollPosition > 100) {
    styleSwitch.value = 'margin-top:0px;'
    scrollVisible.value = false
    showExtension.value = false
  } else {
    styleSwitch.value = 'margin-top:40px;'
    scrollVisible.value = true
  }
  if (!baseStore.isDesktop) {
    styleSwitch.value = 'margin-top:0px;'
    scrollVisible.value = false
    showExtension.value = false
  }
}


// async function getLoggedUser() {
//   const data = { action: 'loggeduser',id: 0 }
//   try {
//     const response = await baseCalls.userGet(data)
//     if (response.data.user) {
//       userStore.setUser(response.data.user)
    
//     } 
//   } catch (err) {
//     console.log(err)
//   } 
// }

// watch(userData, (newValue) => {
//   if (newValue && baseStore.isDesktop) {
//     showMenue.value = true;
//   }else {
//     showMenue.value = false;
//   }
// });

watch(
  () => route.path,
  async () => {
    // Setze showExtension auf false bei jedem Routenwechsel
    showExtension.value = false;
    await getLoggedUser()
  }
);

onMounted(() => {
  restoreUserSession()
  getLoggedUser()
});

</script>
<style>
/* Stil für alle v-btn-Komponenten */
.v-btn {
  text-transform: none; /* Setzt den Text auf normale Buchstaben */
}

ul {

  margin-left: 20px;

}
a {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}


/* Override standard HTML blue color */
:root {
  --blue: #3d1b70;
}

/* Define blue color for all elements */
.blue, .text-blue {
  color: #3d1b70 !important;
}

/* Override browser default blue color */
[color="blue"] {
  color: #3d1b70 !important;
}

.top-strip {
  background: #f1f3f5;
  height: 40px;
  position: fixed;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.top-strip-text {
  font-weight: 400;
  font-size: 14px;
  height: 30px;
  color: #4b5563;
}

.top-strip-copy {
  font-weight: 400;
  font-size: 14px;
  height: 30px;
  color: #6b7280;
}

.brand-row {
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.brand-claim {
  font-weight: 300;
  font-size: 20px;
  color: #4b5563;
}

.brand-claim-strong {
  color: #374151;
  font-weight: 600;
}

.text-muted-brand {
  color: #374151 !important;
}

.header-auth-actions {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.auth-btn {
  border-radius: 0 !important;
  color: #4b5563 !important;
  border-color: #d1d5db !important;
  text-transform: none !important;
  font-weight: 600;
  min-width: 90px;
}

.auth-btn-secondary {
  min-width: 130px;
}
</style>
